import type {API_DataType} from '../../types-telematics';
import FilterInputText from './FilterInputText';

type DataType = 'string' | 'double' | 'int' | 'date' | 'datetime';

interface FilterInputFactoryProps {
    className?: string;
    value?: string;
    placeholder: string;
    maxLength?: number;
    db_autosuggest_column_name?: string;
}

interface FilterInputFactoryCallbacks {
    onChange: (value: string) => boolean;
    isValid?: (value: string) => boolean;
}

const FilterInputFactory = (dataType: API_DataType, props: FilterInputFactoryProps, callbacks: FilterInputFactoryCallbacks) => {
    console.log('FilterInputFactory', dataType, props, callbacks)
    switch (dataType) {
        case 'string':
        case 'double':
        case 'int':
            return FilterInputText('text', props, callbacks);
        case 'date':
            return FilterInputText('date', props, callbacks);
        case 'datetime':
            return FilterInputText('datetime-local', props, callbacks);
        default:
            return FilterInputText('text', props, callbacks);
    }
}

export default FilterInputFactory;